import { __rest, __assign } from 'tslib';
import * as React from 'react';

function IconBlood(_a) {
    _a.primary; var secondary = _a.secondary, circleStroke = _a.circleStroke, circleFill = _a.circleFill, iconFace = _a.iconFace, props = __rest(_a, ["primary", "secondary", "circleStroke", "circleFill", "iconFace"]);
    return (React.createElement("svg", __assign({ width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M22.5 10.5S16 17.297 16 21.75c0 3.728 2.911 6.75 6.5 6.75s6.5-3.022 6.5-6.75c0-4.367-6.5-11.25-6.5-11.25z", fill: secondary }),
        React.createElement("circle", { cx: 20, cy: 20, r: 19.25, stroke: circleStroke, strokeWidth: 1.5, fill: circleFill }),
        React.createElement("path", { d: "M20 10.53s-7 7.18-7 11.88c0 3.93 3.13 7.12 7 7.12s7-3.19 7-7.12c0-4.62-7-11.88-7-11.88z", stroke: iconFace, strokeWidth: 1.5, strokeMiterlimit: 10 })));
}

export { IconBlood as default };
//# sourceMappingURL=icon-blood-sm.esm.js.map
